import StatCard from '../../components/common/StatCard';
import Button from '../../components/common/Button';
import './LazyMarketing.css';

const Ads = () => {
  const stats = [
    { label: 'Ad Spend', value: '$12,400', change: '+$2,100', changeType: 'positive' },
    { label: 'Impressions', value: '2.4M', change: '+340K', changeType: 'positive' },
    { label: 'Clicks', value: '45,200', change: '+8,400', changeType: 'positive' },
    { label: 'ROAS', value: '4.2x', change: '+0.4x', changeType: 'positive' },
  ];

  const platforms = [
    { name: 'Google Ads', spend: '$5,200', roas: '3.8x', status: 'Active' },
    { name: 'Meta Ads', spend: '$4,100', roas: '4.6x', status: 'Active' },
    { name: 'LinkedIn Ads', spend: '$2,300', roas: '2.4x', status: 'Active' },
    { name: 'TikTok Ads', spend: '$800', roas: '5.2x', status: 'Paused' },
  ];

  return (
    <div className="lm-page">
      <div className="lm-page-header">
        <h1 className="lm-page-title">Paid Advertising</h1>
        <p className="lm-page-subtitle">Manage ads across all platforms</p>
      </div>

      <div className="lm-stats-row">
        {stats.map((stat, index) => (
          <StatCard key={index} {...stat} />
        ))}
      </div>

      <div className="lm-section">
        <div className="lm-section-header">
          <h3 className="lm-section-title">Ad Platforms</h3>
          <Button variant="primary" size="sm" icon="plus">Create Ad</Button>
        </div>
        <div className="lm-grid">
          {platforms.map((platform, index) => (
            <div key={index} className="lm-grid-card">
              <div className="lm-grid-card-header">
                <span className="lm-grid-card-title">{platform.name}</span>
                <span className="lm-grid-card-badge" style={{
                  background: platform.status === 'Active' ? 'var(--success-soft)' : 'var(--warning-soft)',
                  color: platform.status === 'Active' ? 'var(--success)' : 'var(--warning)'
                }}>{platform.status}</span>
              </div>
              <div className="lm-grid-card-content">
                <p>Spend: {platform.spend} • ROAS: {platform.roas}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ads;
